export default __webpack_public_path__ + "static/media/Lira-Bara_ Uganda--08.030183.1df14078.JPG";